import React, { useState } from "react";
import "../styles/SuperannuationInfo.css";
import {
  formatAbnDigits,
  formatDigitsOnly,
  getAbnError,
  getAbnErrorRequired,
} from "../utils/australianTaxValidators";

const SuperannuationInfo = ({ onNext, onPrevious, initialData = {} }) => {
  const [data, setData] = useState({
    fundName: initialData.fundName || "",
    spin: initialData.spin || "",
    fundABN: initialData.fundABN || "",
    fundTelephoneNumber: initialData.fundTelephoneNumber || "",
    memberNumber: initialData.memberNumber || "",
  });
  const [fundAbnError, setFundAbnError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "fundABN") {
      const formatted = formatAbnDigits(value);
      setData({ ...data, fundABN: formatted });
      setFundAbnError(getAbnError(formatted) || "");
      return;
    }
    if (name === "memberNumber") {
      setData({ ...data, memberNumber: formatDigitsOnly(value) });
      return;
    }
    setData({ ...data, [name]: value });
  };

  const handleNext = () => {
    const abnErr = getAbnErrorRequired(data.fundABN);
    setFundAbnError(abnErr || "");
    if (abnErr) return;
    onNext(data);
  };

  return (
    <div className="superannuation-info">
      <div className="form-row">
        <label>Fund name</label>
        <input
          type="text"
          name="fundName"
          value={data.fundName}
          onChange={handleChange}
          placeholder="Enter fund name"
          required
        />
      </div>

      <div className="form-row-two-columns">
        <div className="form-column">
          <label>Australian Business Number (ABN)</label>
          <input
            type="text"
            name="fundABN"
            value={data.fundABN}
            onChange={handleChange}
            inputMode="numeric"
            placeholder="Enter ABN (11 digits)"
            maxLength="11"
            pattern="[0-9]{11}"
            className={fundAbnError ? "super-input-error" : ""}
            aria-invalid={!!fundAbnError}
            required
          />
          {fundAbnError ? (
            <p className="super-field-error" role="alert">
              {fundAbnError}
            </p>
          ) : null}
        </div>

        <div className="form-column">
          <label>Unique Superannuation Identifier (USI)</label>
          <input
            type="text"
            name="spin"
            value={data.spin}
            onChange={handleChange}
            placeholder="Enter USI"
            required
          />
        </div>
      </div>

      <div className="form-row">
        <label>Member number (this is listed on your benefit statement)</label>
        <input
          type="text"
          name="memberNumber"
          value={data.memberNumber}
          onChange={handleChange}
          inputMode="numeric"
          pattern="[0-9]+"
          placeholder="Enter member number"
          required
        />
      </div>

      <div className="form-row">
        <label>Fund telephone number (8.00am to 8.00pm AEST, Mon-Fri)</label>
        <input
          type="text"
          name="fundTelephoneNumber"
          value={data.fundTelephoneNumber}
          onChange={handleChange}
          placeholder="Enter fund telephone number"
          required
        />
      </div>

      <div className="form-buttons">
        <button className="superannuation-back-btn" onClick={onPrevious}>
          Back
        </button>
        <button className="superannuation-next-btn" onClick={handleNext}>
          Next
        </button>
      </div>
    </div>
  );
};

export default SuperannuationInfo;
